import { useQuery } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { IDefaultResponseWithData } from "../../models/system/DefaultResponse";
import { nurtureCampaignQueryKeys } from "./queryKeys";
import { INurtureCampaign } from "../../models/nurtureCampaign/NurtureCampaign";
import useQSBuilder from "../../hooks/useQSBuilder";

export function useNurtureCampaign(agencyId: string, campaignId?: string) {
  const { get } = useApiHelper();
  const buildQs = useQSBuilder();

  const nurtureCampaign = useQuery({
    queryKey: nurtureCampaignQueryKeys.single(agencyId, campaignId ?? ""),
    queryFn: () =>
      get(
        `/marketing/${agencyId}/nurture/${campaignId}${buildQs({
          includeRules: true,
        })}`
      ) as unknown as IDefaultResponseWithData<INurtureCampaign>,
    refetchOnWindowFocus: false,
    enabled: !!campaignId,
  });

  return {
    nurtureCampaign,
  };
}
